// Калькулятор алюминиевых перегородок — зеркало backend/order/service/PartitionCalculationService.js.
// При изменении формул держать оба файла в синхроне.

import { resolveGlass, VAT_DEFAULT_PERCENT } from "./partitionCatalog";

const COST_PER_SECTION_BASE =
  20400 + 7500 + 7020 + 3000 + 21500 + 6000 + 10000 + 1000;
const DIVIDER_COST = 1500;
const TEMPERING_SURCHARGE_PER_M2 = 4500;
const RAIL_COST_PER_MM = 17.25;
const DELIVERY_TO_SHOP_DEFAULT = 12000;
const DELIVERY_TO_SHOP_MIRROR = 36000;
const FIXED_OTHER_COSTS = 12000 + 6000 + 9000;
const MARKUP = 0.575;

export const calculatePartitionPrice = (partitionConfig) => {
  if (!partitionConfig) return 0;

  const {
    openingHeight = 0,
    openingWidth = 0,
    sectionsCount = 0,
    glassColor,
    glassTempered = false,
    verticalDividers = 0,
    horizontalDividers = 0,
    designerModifierEnabled = false,
    designerModifierPercent = 0,
    installmentModifierEnabled = false,
    installmentModifierPercent = 0,
    vatModifierEnabled = false,
    vatModifierPercent = VAT_DEFAULT_PERCENT,
  } = partitionConfig;

  if (!openingHeight || !openingWidth || !sectionsCount) return 0;

  const glass = resolveGlass(glassColor);
  const glassPriceBase = glass ? glass.pricePerM2 : 0;
  const actualTempered = glassTempered && glass && glass.canTemper;
  const isMirror = glass ? glass.isMirror : false;

  const costPerSection =
    COST_PER_SECTION_BASE +
    (verticalDividers + horizontalDividers) * DIVIDER_COST;
  const sectionsTotal = costPerSection * sectionsCount;

  const areaSqM = (openingHeight * openingWidth) / 1_000_000;
  const glassPricePerM2 =
    glassPriceBase + (actualTempered ? TEMPERING_SURCHARGE_PER_M2 : 0);
  const glassCost = areaSqM * glassPricePerM2;

  const railCost = openingWidth * RAIL_COST_PER_MM;
  const deliveryToShop = isMirror
    ? DELIVERY_TO_SHOP_MIRROR
    : DELIVERY_TO_SHOP_DEFAULT;
  const otherCosts = deliveryToShop + FIXED_OTHER_COSTS;

  const costBase = sectionsTotal + glassCost + railCost + otherCosts;
  const basePrice = costBase / (1 - MARKUP);

  const designerPct = designerModifierEnabled
    ? Number(designerModifierPercent) || 0
    : 0;
  const installmentPct = installmentModifierEnabled
    ? Number(installmentModifierPercent) || 0
    : 0;
  const rawDivisor = 1 - designerPct / 100 - installmentPct / 100;
  const modifierDivisor = rawDivisor > 0 ? rawDivisor : 1;

  const vatPct = vatModifierEnabled
    ? Number(vatModifierPercent) || VAT_DEFAULT_PERCENT
    : 0;
  const vatMultiplier = 1 + vatPct / 100;

  return Math.round((basePrice / modifierDivisor) * vatMultiplier);
};
